import React from 'react';

const Contact = () => {
    return (
        <div className='register'>
            <h2>Kids Health Care Hospital</h2>
            <h4>Place: House 48, Road 9/A, Jigatala TSO, Dhanmondi, Dhaka-1209</h4>
            <p>Schedule: 10:00am - 09:00pm (Friday holiday)</p>
        </div>
    );
};

export default Contact;